import { EncodeToBase64, findDPAndCliendId, getDecryptLocalStorage, getStorageWithMultiTabCheck, getOrderIdentifier, getProductTypeValue, setEncryptLocalStorage } from "../../utils/global_functions";
import { APPLICATION_TYPE, LOCAL_STORAGE_KEYS, ORDER_PRODUCT_TYPES_VALUES, REVOKE_TAB,DEPOSITORY_CDSL, DEPOSITORY_NSDL, EXCHANGE_TYPES } from "../../utils/global_variables";



const _generateParamsForEdis = (payload,tab) => {
    let loggedInUserInfo = JSON.parse(getStorageWithMultiTabCheck(LOCAL_STORAGE_KEYS.USER_ACTIVE_SESSION));
    const { dpDetails, exchangeName, instrumentType, marketSegmentId, scripsData, productType, isAmo, selectedSettlement, isMultiIsin, edisURL } = payload;
    let ScripDetails = "";
    if (dpDetails.sDepository === DEPOSITORY_CDSL || (dpDetails.sDepository === DEPOSITORY_NSDL && isMultiIsin)) {
        if (scripsData.length > 0) {
            const formattedScripsData = scripsData.map(scrip => {
                return {
                    "ISIN": scrip.sISINCode.toString().trim(),
                    "Quantity": tab===REVOKE_TAB?scrip.eDISRevokeQty:scrip.eDISRequestQty,
                    "ISINName": scrip.sSecurityDesc.toString().replace('&', 'amp;').trim()
                };
            });
            ScripDetails = JSON.stringify(formattedScripsData);
        }
        else {
            const formattedScripsData = [{
                "ISIN": dpDetails.ISIN.toString().trim(),
                "Quantity": dpDetails.edisRequestQty,
                "ISINName": dpDetails.securityDescription.toString().replace('&', 'amp;').trim()
            }];
            ScripDetails = JSON.stringify(formattedScripsData);
        }
    }
    else {
        const formattedScripsData = scripsData.map(scrip => {
            return {
                "ISIN": scrip.sISINCode.toString().trim(),
                "Quantity": tab===REVOKE_TAB?scrip.eDISRevokeQty:scrip.eDISRequestQty,
                "ISINName": scrip.sSecurityDesc.toString().replace('&', 'amp;').trim()
            };
        });
        ScripDetails = JSON.stringify(formattedScripsData);
    }

    let data = findDPAndCliendId(dpDetails, dpDetails.sDepository);
    let edisURLFromAppInfo = edisURL;
    let params = {}
    let strQS=""
    if(tab===REVOKE_TAB){
        strQS = "?userCode=" + loggedInUserInfo?.data?.others?.userCode
        strQS += "&depository=" + dpDetails.sDepository;
        strQS += "&userId=" + loggedInUserInfo?.data?.user_id;
        strQS += "&groupId=" + loggedInUserInfo?.data?.others?.groupId;
        strQS += "&managerIP=" + loggedInUserInfo?.data?.others?.managerIP;
        strQS += "&sessionID=" + loggedInUserInfo?.data?.others?.ocToken;
        strQS += "&dpId=" + data[0];
        strQS += "&clientId=" + data[1];
        strQS += "&productcode=" + "WAVE";
        strQS += "&ScripDetails=" + encodeURIComponent(ScripDetails.replace('&', '$'));
        strQS += "&channel=" + "WEB";
        strQS += "&theme=" + 'D' // BT-113726, EDIS revoke to Non-POA user for NSDL, Samadhan S, 26/09/2023

        // if (arryResponse.sDepository == clsConstants.C_S_EDIS_ODRREQ_DEPOSITORY_NSDL && multiIsinEnabled && multiIsinEnabled.toString().toUpperCase() == "TRUE") {
        strQS += "&ReqId=" + dpDetails.sDepository === DEPOSITORY_NSDL && isMultiIsin ? getOrderIdentifier() : ""
        edisURLFromAppInfo += strQS;
        params = {
            userCode: loggedInUserInfo?.data?.others?.userCode,
            managerIP: loggedInUserInfo?.data?.others?.managerIP,
            sessionID: loggedInUserInfo?.data?.others?.ocToken,
            channel: "MOB",
            dpId: data[0],
            clientId: data[1],
            depository: dpDetails.sDepository,
            ScripDetails: encodeURIComponent(ScripDetails.replace('&', '$')),
            userId: loggedInUserInfo?.data?.user_id,
            groupId: loggedInUserInfo?.data?.others?.groupId,
            productCode: "WAVE",
            ReqId: dpDetails.sDepository === DEPOSITORY_NSDL && isMultiIsin ? getOrderIdentifier() : ""
        }
    }else{
        params= {
            userCode: loggedInUserInfo?.data?.others?.userCode,
            managerIP: loggedInUserInfo?.data?.others?.managerIP,
            sessionID: loggedInUserInfo?.data?.others?.ocToken,
            channel: "WEB",
            isin: dpDetails.ISIN ? dpDetails.ISIN.trim() : '',
            isinName: dpDetails.securityDescription ? dpDetails.securityDescription.trim() : '',
            exchangeCd: exchangeName,
            product: 1,
            instrument: instrumentType === EXCHANGE_TYPES.CONST_EQUITY ? "Equity" : instrumentType,
            quantity: dpDetails.edisRequestQty || 0,
            dpId: data[0],
            clientId: data[1],
            depository: dpDetails.sDepository,
            productcode: APPLICATION_TYPE,
            MarketSegId: marketSegmentId,
            ScripDetails: ScripDetails,
            userId: loggedInUserInfo?.data?.user_id,
            groupId: loggedInUserInfo?.data?.others?.groupId,
            producttype: productType ? getProductTypeValue(productType) : ORDER_PRODUCT_TYPES_VALUES.DELIVERY_VALUE,
            amo: isAmo ? "Y" : "N",
            SettlmtCycle: selectedSettlement === 1 ? "T1" : "T2",
            ReqId: dpDetails.sDepository === DEPOSITORY_NSDL && isMultiIsin ? getOrderIdentifier() : ""
        };
    }

    return { edisURLFromAppInfo, params };
};

// const _generateRevokeParamsForEdis = (payload) => {
//     const { dpDetails, scripsData, edisURL, isMultiIsin } = payload;
//     let ScripDetails = "";
//     if (edisURL && edisURL.length > 0) {
//         if(scripsData.length > 0) {
//             const formattedScripsData = scripsData.map(scrip => {
//                 return {
//                     "ISIN": scrip.sISINCode.toString().trim(),
//                     "Quantity": scrip.eDISRevokeQty,
//                     "ISINName": scrip.sSecurityDesc.toString().replace('&', 'amp;').trim()
//                 }
//             })
//             ScripDetails = JSON.stringify(formattedScripsData);
//         }
//         else {
//             const formattedScripsData = [{
//                 "ISIN": dpDetails.ISIN.toString().trim(),
//                 "Quantity": dpDetails.QuantityToHold,
//                 "ISINName": dpDetails.SecurityDescription.toString().replace('&', 'amp;').trim()
//             }]
//             ScripDetails = JSON.stringify(formattedScripsData);
//         }
//     }
//     let data = findDPAndCliendId(dpDetails, dpDetails.sDepository);

//     let edisURLFromAppInfo = edisURL;
//     let params = {
//         userCode: loggedInUserInfo?.data?.others?.userCode,
//         depository: dpDetails.sDepository,
//         userId: loggedInUserInfo?.data?.user_id,
//         groupId: loggedInUserInfo?.data?.others?.groupId,
//         managerIP: loggedInUserInfo?.data?.others?.managerIP,
//         sessionID: loggedInUserInfo?.data?.others?.ocToken,
//         dpId: data[0],
//         clientId: data[1],
//         productcode: APPLICATION_TYPE,
//         ScripDetails: ScripDetails,
//         channel: "WEB",
//         theme: loggedInUserInfo?.data?.defaultTheme === "DARK" ? "D" : "L",
//         ReqId: dpDetails.sDepository === DEPOSITORY_NSDL && isMultiIsin ? getOrderIdentifier() : "",

//     }
//     return { edisURLFromAppInfo, params }
//     }


// Ajitesh 15/03/2024 - New function to handle window for eDIS as done in Aero
const _executeEdisOnline = (payload,tab) => {
    return new Promise((resolve, reject) => {
        try {
            const { isMultiIsin } = payload;
            const { edisURLFromAppInfo, params } = _generateParamsForEdis(payload,tab);
            let windowObject = null;
            if(tab!==REVOKE_TAB){
                const form = document.createElement("form");
                form.setAttribute("name", "edisForm");
                form.setAttribute("action", edisURLFromAppInfo);
                form.setAttribute("method", "Post"); //Deepti b. set form method to post for 100+ scrips authorization


                for (const key in params) {
                    if (params.hasOwnProperty(key)) {
                        const input = document.createElement("input");
                        input.type = "hidden";
                        input.name = key;
                        input.value = params[key];
                        form.appendChild(input);
                    }
                }
                windowObject = window.open("", "_blank", "width=1000,height=800,location=no,toolbar=no,menubar=no,resizable=no");
                windowObject.document.body.appendChild(form);
                windowObject.document.forms[0].submit();
            }else{
                windowObject = window.open(edisURLFromAppInfo,'_blank',"width=1000,height=800,location=no,toolbar=no,menubar=no,resizable=no")
            }

            if (windowObject) {
                const timer = setInterval(() => {
                    if (windowObject.closed) {
                        clearInterval(timer);
                        reject("popup closed");
                    }
                }, 1000);
            }
            else {
                reject("popup not created");
            }

            window.addEventListener("message", (event) => {
                if (event.data.messageCode === 'EDISResp' && windowObject.parent !== null) {
                    const jsonData = JSON.parse(event.data.respdata);
                    let status = tab===REVOKE_TAB ? jsonData?.some(scrip => scrip.Status === "Success"):jsonData.Status;
                    if (status || params.depository === DEPOSITORY_CDSL || (params.depository === DEPOSITORY_NSDL && isMultiIsin)) {
                        if ((jsonData.ScripDetails||jsonData?.length) && (params.depository === DEPOSITORY_CDSL || params.depository === DEPOSITORY_NSDL)) {
                            const response = jsonData?.ScripDetails? JSON.parse(jsonData.ScripDetails): jsonData;

                            const arrSuccess = response.filter(scrip => scrip.Status === "Success");

                            if (arrSuccess.length > 0) {
                                resolve(arrSuccess);
                                windowObject.close();
                            }
                            else {
                                reject([]);
                                windowObject.close();
                            }
                        }
                        else {
                            if (jsonData.StatusCode === "ERR047" || jsonData.Status === "Failure") {
                                reject('User has pressed cancel button or Transaction Failed at ' + params.depository);
                            }
                            else {
                                resolve({ refTxnNo: jsonData.RefNum, TotalAvailableQty: jsonData.BlkQty });
                            }
                            windowObject.close();
                        }
                    }
                    else {
                        reject('transaction failed -> NSDL');
                        windowObject.close();
                    }
                }
            });
        } catch (error) {
            console.error(error.message);
            reject(error.message);
        }
    });
};

// Ajitesh : 17/01/2024: BT-109135: Breeze eDIS implementation centralised controller function to check first login of day - Start
const _checkIsFirstLoginOfDay = (loginSessionInfo) => {
    // No key in storage so set login date coming from api
    if (!localStorage.getItem(LOCAL_STORAGE_KEYS.FIRST_LOGIN_OF_DAY)) {
        // Setting time in local storage as Unix time
        setEncryptLocalStorage(LOCAL_STORAGE_KEYS.FIRST_LOGIN_OF_DAY, JSON.stringify(new Date(loginSessionInfo?.data?.login_time).getTime()));
    }
    // Key stored in storage hence compare current login time from api with value in local storage
    else {
        // time from api
        const nowLoginTime = new Date(loginSessionInfo?.data?.login_time);
        // time from storage
        const lastLoginTime = new Date(JSON.parse(getDecryptLocalStorage(LOCAL_STORAGE_KEYS.FIRST_LOGIN_OF_DAY)));
        // if current time from api > time from storage and dates are diffrent means first login of day; so store current time in localstorage
        if (nowLoginTime.getTime() > lastLoginTime.getTime() && nowLoginTime.getDate() !== lastLoginTime.getDate()) {
            //localStorage.setItem(LOCAL_STORAGE_KEYS.FIRST_LOGIN_OF_DAY, JSON.stringify(nowLoginTime));
            setEncryptLocalStorage(LOCAL_STORAGE_KEYS.FIRST_LOGIN_OF_DAY, JSON.stringify(nowLoginTime.getTime()));
        }
    }
};
// Ajitesh : 17/01/2024: BT-109135: Breeze eDIS implementation centralised controller function to check first login of day - End

// Ajitesh: 26/02/2024: BT-122859: Breeze pledge implementation - Start
const _generateUrlForPledgeUnpledge = (baseUrl) => {
    let loggedInUserInfo = JSON.parse(getStorageWithMultiTabCheck(LOCAL_STORAGE_KEYS.USER_ACTIVE_SESSION));
    let theme = getDecryptLocalStorage("THEME");
    let URL = baseUrl + "PledgeRequest.aspx";
    let queryParams = "UserId=" + encodeURIComponent(loggedInUserInfo?.data?.user_id);
    queryParams += "&GroupId=" + encodeURIComponent(loggedInUserInfo?.data?.others?.groupId);
    queryParams += "&Product=" + APPLICATION_TYPE; // Deepti B. [Breez-8]: product should be current application type in pledge-unpledged request url
    queryParams += "&ManagerIP=" + encodeURIComponent(loggedInUserInfo?.data?.others?.managerIP);
    queryParams += "&DealerCode=" + encodeURIComponent(loggedInUserInfo?.data?.others?.userCode);
    queryParams += "&GroupCode=" + encodeURIComponent(loggedInUserInfo?.data?.others?.groupCode);
    queryParams += theme ? "&theme=" + "D" : "&theme=" + "L";
    queryParams += "&SessionId=" + encodeURIComponent(loggedInUserInfo?.data?.others?.ocToken);
    let type = 1;
    let pledgeUnpledgeURL = URL + `?type=${type}&enct=` + EncodeToBase64(queryParams);
    return pledgeUnpledgeURL;
};
// Ajitesh: 26/02/2024: BT-122859: Breeze pledge implementation - End

export { _generateParamsForEdis, _executeEdisOnline, _checkIsFirstLoginOfDay, _generateUrlForPledgeUnpledge };